var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfileMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 39,
    viewBox: "0 0 36 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.4477 10.1094C25.116 14.5755 21.725 18.2188 18.0024 18.2188C14.2797 18.2188 10.8828 14.5763 10.5571 10.1094C10.2186 5.46339 13.5183 2 18.0024 2C22.4865 2 25.7861 5.54786 25.4477 10.1094Z",
    stroke: "#151833",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2184 23.3398C10.8695 23.3398 3.41085 27.4372 2.03061 35.171C1.86421 36.1032 2.38623 36.9978 3.35172 36.9978H33.085C34.0514 36.9978 34.5734 36.1032 34.407 35.171C33.0259 27.4372 25.5672 23.3398 18.2184 23.3398Z",
    stroke: "#151833",
    strokeWidth: 2.5,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileMobile);
export default __webpack_public_path__ + "static/media/ProfileMobile.67d7055e16cf7aeeda87fef284f6bdc8.svg";
export { ForwardRef as ReactComponent };